export const OptionLayoutDiagram = (
  <svg width="64" height="50" viewBox="0 0 64 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.6665 7.8125C6.6665 6.94956 7.38285 6.25 8.2665 6.25H56.2665C57.1502 6.25 57.8665 6.94956 57.8665 7.8125C57.8665 8.67544 57.1502 9.375 56.2665 9.375H8.2665C7.38285 9.375 6.6665 8.67544 6.6665 7.8125Z"
      fill="#DFE2E7"
    />
    <path
      d="M6.6665 12.5C6.6665 11.6371 7.38285 10.9375 8.2665 10.9375H27.4665C28.3502 10.9375 29.0665 11.6371 29.0665 12.5C29.0665 13.3629 28.3502 14.0625 27.4665 14.0625H8.2665C7.38285 14.0625 6.6665 13.3629 6.6665 12.5Z"
      fill="#DFE2E7"
    />
    <path
      d="M6.6665 20.3125C6.6665 19.4496 7.38285 18.75 8.2665 18.75H56.2665C57.1501 18.75 57.8665 19.4496 57.8665 20.3125V23.4375C57.8665 24.3004 57.1501 25 56.2665 25H8.2665C7.38285 25 6.6665 24.3004 6.6665 23.4375V20.3125Z"
      fill="#BAC0CA"
    />
    <path
      d="M6.6665 29.6875C6.6665 28.8246 7.38285 28.125 8.2665 28.125H56.2665C57.1501 28.125 57.8665 28.8246 57.8665 29.6875V32.8125C57.8665 33.6754 57.1501 34.375 56.2665 34.375H8.2665C7.38285 34.375 6.6665 33.6754 6.6665 32.8125V29.6875Z"
      fill="#BAC0CA"
    />
    <path
      d="M6.6665 39.0625C6.6665 38.1996 7.38285 37.5 8.2665 37.5H56.2665C57.1501 37.5 57.8665 38.1996 57.8665 39.0625V42.1875C57.8665 43.0504 57.1501 43.75 56.2665 43.75H8.2665C7.38285 43.75 6.6665 43.0504 6.6665 42.1875V39.0625Z"
      fill="#BAC0CA"
    />
  </svg>
);

export const OptionLayoutDiagramSelected = (
  <svg width="64" height="50" viewBox="0 0 64 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 2C0 0.895432 0.895431 0 2 0H62C63.1046 0 64 0.89543 64 2V48C64 49.1046 63.1046 50 62 50H2C0.895431 50 0 49.1046 0 48V2Z"
      fill="#E3F4FA"
    />
    <path
      d="M6.6665 7.8125C6.6665 6.94956 7.38285 6.25 8.2665 6.25H56.2665C57.1502 6.25 57.8665 6.94956 57.8665 7.8125C57.8665 8.67544 57.1502 9.375 56.2665 9.375H8.2665C7.38285 9.375 6.6665 8.67544 6.6665 7.8125Z"
      fill="#77CCEB"
    />
    <path
      d="M6.6665 12.5C6.6665 11.6371 7.38285 10.9375 8.2665 10.9375H27.4665C28.3502 10.9375 29.0665 11.6371 29.0665 12.5C29.0665 13.3629 28.3502 14.0625 27.4665 14.0625H8.2665C7.38285 14.0625 6.6665 13.3629 6.6665 12.5Z"
      fill="#77CCEB"
    />
    <path
      d="M6.6665 20.3125C6.6665 19.4496 7.38285 18.75 8.2665 18.75H56.2665C57.1501 18.75 57.8665 19.4496 57.8665 20.3125V23.4375C57.8665 24.3004 57.1501 25 56.2665 25H8.2665C7.38285 25 6.6665 24.3004 6.6665 23.4375V20.3125Z"
      fill="#77CCEB"
    />
    <path
      d="M6.6665 29.6875C6.6665 28.8246 7.38285 28.125 8.2665 28.125H56.2665C57.1501 28.125 57.8665 28.8246 57.8665 29.6875V32.8125C57.8665 33.6754 57.1501 34.375 56.2665 34.375H8.2665C7.38285 34.375 6.6665 33.6754 6.6665 32.8125V29.6875Z"
      fill="#77CCEB"
    />
    <path
      d="M6.6665 39.0625C6.6665 38.1996 7.38285 37.5 8.2665 37.5H56.2665C57.1501 37.5 57.8665 38.1996 57.8665 39.0625V42.1875C57.8665 43.0504 57.1501 43.75 56.2665 43.75H8.2665C7.38285 43.75 6.6665 43.0504 6.6665 42.1875V39.0625Z"
      fill="#77CCEB"
    />
  </svg>
);

export const OptionWithMediaLayoutDiagram = (
  <svg width="64" height="50" viewBox="0 0 64 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M62 1H2C1.44772 1 1 1.44772 1 2V48C1 48.5523 1.44772 49 2 49H62C62.5523 49 63 48.5523 63 48V2C63 1.44772 62.5523 1 62 1ZM2 0C0.895431 0 0 0.895432 0 2V48C0 49.1046 0.895431 50 2 50H62C63.1046 50 64 49.1046 64 48V2C64 0.895431 63.1046 0 62 0H2Z"
      fill="#DFE2E7"
    />
    <path
      d="M6.6665 7.8125C6.6665 6.94956 7.38285 6.25 8.2665 6.25H56.2665C57.1502 6.25 57.8665 6.94956 57.8665 7.8125C57.8665 8.67544 57.1502 9.375 56.2665 9.375H8.2665C7.38285 9.375 6.6665 8.67544 6.6665 7.8125Z"
      fill="#DFE2E7"
    />
    <path
      d="M6.6665 12.5C6.6665 11.6371 7.38285 10.9375 8.2665 10.9375H27.4665C28.3502 10.9375 29.0665 11.6371 29.0665 12.5C29.0665 13.3629 28.3502 14.0625 27.4665 14.0625H8.2665C7.38285 14.0625 6.6665 13.3629 6.6665 12.5Z"
      fill="#DFE2E7"
    />
    <path
      d="M32.3999 20.3125C32.3999 19.4496 33.1162 18.75 33.9999 18.75H56.2665C57.1502 18.75 57.8665 19.4496 57.8665 20.3125V23.4375C57.8665 24.3004 57.1502 25 56.2665 25H33.9999C33.1162 25 32.3999 24.3004 32.3999 23.4375V20.3125Z"
      fill="#DFE2E7"
    />
    <path
      d="M32.3999 29.6875C32.3999 28.8246 33.1162 28.125 33.9999 28.125H56.2665C57.1502 28.125 57.8665 28.8246 57.8665 29.6875V32.8125C57.8665 33.6754 57.1502 34.375 56.2665 34.375H33.9999C33.1162 34.375 32.3999 33.6754 32.3999 32.8125V29.6875Z"
      fill="#DFE2E7"
    />
    <path
      d="M32.3999 39.0625C32.3999 38.1996 33.1162 37.5 33.9999 37.5H56.2665C57.1502 37.5 57.8665 38.1996 57.8665 39.0625V42.1875C57.8665 43.0504 57.1502 43.75 56.2665 43.75H33.9999C33.1162 43.75 32.3999 43.0504 32.3999 42.1875V39.0625Z"
      fill="#DFE2E7"
    />
    <path
      d="M7 20C7 19.4477 7.44772 19 8 19H29C29.5523 19 30 19.4477 30 20V42.5C30 43.0523 29.5523 43.5 29 43.5H8C7.44772 43.5 7 43.0523 7 42.5L7 20Z"
      fill="#BAC0CA"
    />
  </svg>
);

export const OptionWithMediaLayoutDiagramSelected = (
  <svg width="64" height="50" viewBox="0 0 64 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 2C0 0.895432 0.895431 0 2 0H62C63.1046 0 64 0.89543 64 2V48C64 49.1046 63.1046 50 62 50H2C0.895431 50 0 49.1046 0 48V2Z"
      fill="#E3F4FA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M62 1H2C1.44772 1 1 1.44772 1 2V48C1 48.5523 1.44772 49 2 49H62C62.5523 49 63 48.5523 63 48V2C63 1.44772 62.5523 1 62 1ZM2 0C0.895431 0 0 0.895432 0 2V48C0 49.1046 0.895431 50 2 50H62C63.1046 50 64 49.1046 64 48V2C64 0.895431 63.1046 0 62 0H2Z"
      fill="#C4E9F6"
    />
    <path
      d="M6.6665 7.8125C6.6665 6.94956 7.38285 6.25 8.2665 6.25H56.2665C57.1502 6.25 57.8665 6.94956 57.8665 7.8125C57.8665 8.67544 57.1502 9.375 56.2665 9.375H8.2665C7.38285 9.375 6.6665 8.67544 6.6665 7.8125Z"
      fill="#77CCEB"
    />
    <path
      d="M6.6665 12.5C6.6665 11.6371 7.38285 10.9375 8.2665 10.9375H27.4665C28.3502 10.9375 29.0665 11.6371 29.0665 12.5C29.0665 13.3629 28.3502 14.0625 27.4665 14.0625H8.2665C7.38285 14.0625 6.6665 13.3629 6.6665 12.5Z"
      fill="#77CCEB"
    />
    <path
      d="M32.3999 20.3125C32.3999 19.4496 33.1162 18.75 33.9999 18.75H56.2665C57.1502 18.75 57.8665 19.4496 57.8665 20.3125V23.4375C57.8665 24.3004 57.1502 25 56.2665 25H33.9999C33.1162 25 32.3999 24.3004 32.3999 23.4375V20.3125Z"
      fill="#77CCEB"
    />
    <path
      d="M32.3999 29.6875C32.3999 28.8246 33.1162 28.125 33.9999 28.125H56.2665C57.1502 28.125 57.8665 28.8246 57.8665 29.6875V32.8125C57.8665 33.6754 57.1502 34.375 56.2665 34.375H33.9999C33.1162 34.375 32.3999 33.6754 32.3999 32.8125V29.6875Z"
      fill="#77CCEB"
    />
    <path
      d="M32.3999 39.0625C32.3999 38.1996 33.1162 37.5 33.9999 37.5H56.2665C57.1502 37.5 57.8665 38.1996 57.8665 39.0625V42.1875C57.8665 43.0504 57.1502 43.75 56.2665 43.75H33.9999C33.1162 43.75 32.3999 43.0504 32.3999 42.1875V39.0625Z"
      fill="#77CCEB"
    />
    <path
      d="M7 20C7 19.4477 7.44772 19 8 19H29C29.5523 19 30 19.4477 30 20V42.5C30 43.0523 29.5523 43.5 29 43.5H8C7.44772 43.5 7 43.0523 7 42.5L7 20Z"
      fill="#77CCEB"
    />
  </svg>
);
